import React from 'react';
import classnames from 'classnames';

interface Props {
  handFull: boolean,
  isFetching: boolean,
  noCards: boolean,
  onClick: () => void,
}

export default function SmallDeckComponent({
  handFull,
  isFetching,
  noCards,
  onClick,
}: Props) {
  return (
    <div className="media__body">
      <button
        type="button"
        tabIndex={-1}
        className={classnames(
          'deck deck--small-media',
          handFull && !noCards && 'deck--full',
          noCards && 'deck--empty',
          isFetching && 'deck--fetching',
        )}
        onClick={onClick}
      />
    </div>
  );
}

SmallDeckComponent.displayName = 'SmallDeckComponent';
